/**
 * The name of the bundled audio file which will be played for the incoming chat
 * message sound.
 *
 * @type {string}
 */
export const INCOMING_MSG_SOUND_FILE = 'incomingMessage.mp3';
export const KNOCK_ONE_SOUND_FILE = 'knock-1.mp3';
export const KNOCK_TWO_SOUND_FILE = 'knock-3.mp3';
export const JOIN_AUDIO_SOUND_FILE = 'join-audio.mp3';
export const LEAVE_AUDIO_SOUND_FILE = 'left-audio.mp3';
